import { fetchAuthAPI } from './client';

// Analytics 데이터 타입
export interface AnalyticsOverview {
  todayVisitors: number;
  todayPageViews: number;
  totalVisitors: number;
  totalPageViews: number;
  popularPages: Array<{
    path: string;
    views: number;
  }>;
  countriesData: Array<{
    country: string;
    visitors: number;
  }>;
  devicesData: Array<{
    device: string;
    percentage: number;
  }>;
  dailyStats: Array<{
    date: string;
    pageViews: number;
    visitors: number;
  }>;
  monthlyStats: Array<{
    month: string;
    pageViews: number;
    visitors: number;
  }>;
}

export interface RealtimeAnalytics {
  activeUsers: number;
  activePages: Array<{
    path: string;
    users: number;
  }>;
}

/**
 * Analytics 개요 데이터 가져오기 (관리자 인증 필요)
 */
export async function getAnalyticsOverview(): Promise<AnalyticsOverview> {
  return fetchAuthAPI<AnalyticsOverview>('/analytics/overview');
}

/**
 * 실시간 Analytics 데이터 가져오기 (관리자 인증 필요)
 */
export async function getRealtimeAnalytics(): Promise<RealtimeAnalytics> {
  return fetchAuthAPI<RealtimeAnalytics>('/analytics/realtime');
}
